/**
 * La marca del club en el panel: la paleta de `@kiap/marca` volcada en variables
 * CSS. La aritmética vive en el paquete, compartida con las Apps; aquí solo el
 * nombre de cada variable.
 *
 * Las variables se aplican en el elemento raíz del panel y **solo del panel**: el
 * back office es neutro siempre, porque si llevara la marca del club se pierde la
 * referencia de en qué club estás (§10).
 */
import { paletaDeMarca, type Marca } from '@kiap/marca';

export * from '@kiap/marca';

export function variablesDeMarca(
  marca: Marca,
  aspecto: 'claro' | 'oscuro' = 'claro'
): Record<string, string> {
  const p = paletaDeMarca(marca, aspecto);
  return {
    '--marca': p.base,
    '--marca-texto': p.texto,
    '--marca-interfaz': p.interfaz,
    '--marca-contraste': p.contraste,
    '--marca-suave': p.suave,
    '--marca-borde': p.borde,
    '--marca-hundido': p.hundido,
  };
}
